//测试地址↓↓↓↓↓↓↓
//export default 'http://192.168.0.0:80/';
export default 'https://api.bats-bio.com/ajax/';


// WEBPACK FOOTER //
// ./src/components/http/baseUrl.js